(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/andra-chansen-banners/assets/javascripts/row-banners/after-dromvinsten-row.js') >= 0) return;  svs.modules.push('/components/numbergames/andra-chansen-banners/assets/javascripts/row-banners/after-dromvinsten-row.js'); 
'use strict';

const _excluded = ["afterDromvinstenChances"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
class AfterDromvinstenRow extends svs.numbergames.andra_chansen_banners.RowBannerBase {
  constructor(_ref) {
    let {
        afterDromvinstenChances
      } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);
    super(_objectSpread({
      bannerOptions: {
        afterDromvinstenChances
      }
    }, props));
  }
  get iconClassName() {
    return 'js-after-dromvinsten-row-info-icon';
  }
  get infoDialogTitle() {
    return 'Andra Chansen efter Drömvinsten';
  }
  get infoDialogMessages() {
    return ['En extra Andra Chansen-dragning lördag veckan efter Drömvinsten föll ut. Fram tills dess får du dubbla chanser för varje rad.'];
  }
  setStatus(_ref2) {
    let {
      afterDromvinstenChances
    } = _ref2;
    this.numberOfChances = afterDromvinstenChances;
  }
  createDrawNameElement() {
    const dromvinstenCloud = document.createElement('span');
    dromvinstenCloud.classList.add('andra-chansen-efter-dromvinsten-img-holder');
    dromvinstenCloud.appendChild(this.createCloudImage());
    const fragment = document.createDocumentFragment();
    fragment.appendChild(document.createTextNode('Andra Chansen efter '));
    fragment.appendChild(dromvinstenCloud);
    fragment.appendChild(document.createTextNode(': '));
    return fragment;
  }
  createCloudImage() {
    const cloud = new Image();
    cloud.src = "".concat(svs.core.config.data.svsconfig.cdn, "/images/numbergames/andra-chansen-banners/dromvinstmolnet.png");
    cloud.alt = 'Drömvinsten';
    cloud.classList.add('andra-chansen-efter-dromvinsten-cloud');
    return cloud;
  }
}
svs.numbergames.andra_chansen_banners.AfterDromvinstenRow = AfterDromvinstenRow;
 })(window);